/**
 * Badge Enum
 */
export var BadgePositionEnum;
(function (BadgePositionEnum) {
    BadgePositionEnum["TOP_LEFT"] = "top-left";
    BadgePositionEnum["TOP_RIGHT"] = "top-right";
    BadgePositionEnum["BOTTOM_LEFT"] = "bottom-left";
    BadgePositionEnum["BOTTOM_RIGHT"] = "bottom-right";
})(BadgePositionEnum || (BadgePositionEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFkZ2VFbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vY29tcG9uZW50cy9iYWRnZS9CYWRnZUVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxpQkFLWDtBQUxELFdBQVksaUJBQWlCO0lBQzNCLDBDQUFxQixDQUFBO0lBQ3JCLDRDQUF1QixDQUFBO0lBQ3ZCLGdEQUEyQixDQUFBO0lBQzNCLGtEQUE2QixDQUFBO0FBQy9CLENBQUMsRUFMVyxpQkFBaUIsS0FBakIsaUJBQWlCLFFBSzVCIn0=